import { render, staticRenderFns } from "./MovableModal.vue?vue&type=template&id=574ec1e4&scoped=true&"
import script from "./MovableModal.vue?vue&type=script&lang=js&"
export * from "./MovableModal.vue?vue&type=script&lang=js&"
import style0 from "./MovableModal.vue?vue&type=style&index=0&id=574ec1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ec1e4",
  null
  
)

export default component.exports